// productEditorStore
import { Category } from '@/pages/mall/ProductEditor/index.type';
import { create } from 'zustand';

interface ProductEditorState {
    categories1: Category | null;
    categories2: Category | null;
    categories3: Category | null;
    categories4: Category | null;
    categories5: Category | null;

    // Actions
    setCategories1: React.Dispatch<React.SetStateAction<Category | null>>;
    setCategories2: React.Dispatch<React.SetStateAction<Category | null>>;
    setCategories3: React.Dispatch<React.SetStateAction<Category | null>>;
    setCategories4: React.Dispatch<React.SetStateAction<Category | null>>;
    setCategories5: React.Dispatch<React.SetStateAction<Category | null>>;
}

const productEditorStore = create<ProductEditorState>((set) => ({
    // Initial states
    categories1: null,
    categories2: null,
    categories3: null,
    categories4: null,
    categories5: null,

    // Actions
    setCategories1: (updater) =>
        set((state) => ({
            categories1:
                typeof updater === 'function'
                    ? (updater as (prevState: Category | null) => Category | null)(state.categories1)
                    : updater,
        })),
    setCategories2: (updater) =>
        set((state) => ({
            categories2:
                typeof updater === 'function'
                    ? (updater as (prevState: Category | null) => Category | null)(state.categories2)
                    : updater,
        })),
    setCategories3: (updater) =>
        set((state) => ({
            categories3:
                typeof updater === 'function'
                    ? (updater as (prevState: Category | null) => Category | null)(state.categories3)
                    : updater,
        })),
    setCategories4: (updater) =>
        set((state) => ({
            categories4:
                typeof updater === 'function'
                    ? (updater as (prevState: Category | null) => Category | null)(state.categories4)
                    : updater,
        })),
    setCategories5: (updater) =>
        set((state) => ({
            categories5:
                typeof updater === 'function'
                    ? (updater as (prevState: Category | null) => Category | null)(state.categories5)
                    : updater,
        })),
}));

export default productEditorStore;
